/**
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="testimonials-carousel"></div>
 */

 import 'slick-carousel';

 $( function() {
     $( '[data-component="p2-advantage-slider"]' ).each( function() {
         let $holder = $( this );
 
         $holder.slick(
             {
                rows: 0,
                dots: true,
                arrows: true,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="icon-p2-left"></i></button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="icon-p2-right"></i></button>',
                slidesToShow: 1,
                swipeToSlide: true,
                slidesToScroll: 1,
                centerMode: false,
                speed:300,
                lazyLoad:true,
                 focusOnSelect: true,
                 focusOnChange: true,
                //  responsive:  [
                //     {
                //         breakpoint: 1199,
                //         settings: {
                //             slidesToShow: 2,
                //             slidesToScroll: 1,
                //            //  variableWidth: true,
                //             centerMode: false,
                //            //  centerPadding: '40px',
                //             arrows:true,
                //            //  variableWidth:true
                //         },
                //     },{
                //         breakpoint: 767,
                //         settings: {
                //             slidesToShow: 1,
                //             slidesToScroll: 1,
                //            //  variableWidth: true,
                //             centerMode: false,
                //            //  centerPadding: '40px',
                //             arrows:true,
                //            //  variableWidth:true
                //         },
                //     },
                //     {
                //         breakpoint: 480,
                //         settings: {
                //             slidesToShow: 1,
                //             slidesToScroll: 1,
                //            //  variableWidth: true,
                //             // centerMode: true,
                //            //  centerPadding: '40px',
                //             arrows:true,
                //             slickCurrentSlide:1,
                //            //  variableWidth:true
                //         },
                //     },
                //  ],
             }
         );
 
     } );
 } );
 